/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAllowableFreightViewProps } from './allowable-freight';
import { Progress } from 'reactstrap';
import { AllowableFreightProgressBarClassEnum } from './utils/AllowableFreightProgressBarEnum';

export default (props: IAllowableFreightViewProps) => {
    const {
        state: { maxLimit, limitReached, mustShipLTL, oversizedItem, containsOil, errorMessage, cartFreight }
    } = props;
    const minimumRange = 0;

    const getTickerColourClass = () => {
        //works on a priority system
        if (mustShipLTL) {
            return AllowableFreightProgressBarClassEnum.Red;
        }
        if (oversizedItem || containsOil) {
            return AllowableFreightProgressBarClassEnum.Yellow;
        }
        if (limitReached) {
            return AllowableFreightProgressBarClassEnum.Green;
        }
        return AllowableFreightProgressBarClassEnum.Red;
    };

    const getValueForLabel = (value: string | number) => {
        const formattedValue = !props.state.isUnitCount ? props.context.cultureFormatter.formatCurrency(value) : value;
        return formattedValue.toString();
    };

    if (!props.state.cartFreight && !props.state.maxLimit) {
        return null;
    }
    return (
        <div className='row ms-allowable-freight ms-allowable-freight__heading'>
            <div className='col'>
                <h4 className='ms-allowable-freight__label'>{`${props.resources.sliderLabel}: ${getValueForLabel(cartFreight)}`}</h4>
                <div className='row'>
                    <span className='range-text'>{getValueForLabel(minimumRange)}</span>
                    <Progress
                        className={`ms-allowable-freight__slider ${getTickerColourClass()}`}
                        min={minimumRange}
                        max={maxLimit}
                        value={Math.min(cartFreight, maxLimit)}
                    />
                    <span className='range-text'>{getValueForLabel(maxLimit)}</span>
                </div>
                {errorMessage && <div className='ms-allowable-freight__message'>{errorMessage}</div>}
            </div>
        </div>
    );
};
